export default __webpack_public_path__ + "atomic/_patterns/03-organisms/facets-item-list/_facets-item-list.twig";